import { EvalStack } from '@swim/recon';
import { Model } from './model';
var Directive = (function () {
    function Directive() {
        this._model = null;
    }
    Object.defineProperty(Directive.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    Directive.prototype.setModel = function (model) {
        var oldModel = this._model;
        if (model) {
            if (oldModel) {
                throw new Error();
            }
            this._model = model;
            this.didSetModel(model);
        }
        else if (oldModel) {
            this._model = null;
            this.didSetModel(null);
        }
    };
    Directive.prototype.didSetModel = function (model) {
    };
    Directive.prototype.didInsertChildModel = function (childModel) {
    };
    Directive.prototype.didRemoveChildModel = function (childModel) {
    };
    Directive.prototype.willRestate = function () {
    };
    Directive.prototype.didRestate = function () {
    };
    Directive.prototype.willRemodel = function (state, stack) {
    };
    Directive.prototype.didRemodel = function (state, stack) {
    };
    Directive.prototype.setData = function (data) {
    };
    Directive.prototype.setStyle = function (style) {
    };
    Directive.prototype.stack = function () {
        if (this._model) {
            return this._model.stack();
        }
        else {
            return EvalStack.of(Model.GlobalScope);
        }
    };
    Directive.prototype.injectStack = function (stack) {
    };
    return Directive;
}());
export { Directive };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlyZWN0aXZlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZGlyZWN0aXZlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBQyxTQUFTLEVBQVMsTUFBTSxhQUFhLENBQUM7QUFDOUMsT0FBTyxFQUFDLEtBQUssRUFBQyxNQUFNLFNBQVMsQ0FBQztBQUU5QjtJQUlFO1FBQ0UsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUM7SUFDckIsQ0FBQztJQUVELHNCQUFJLDRCQUFLO2FBQVQ7WUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUNyQixDQUFDOzs7T0FBQTtJQUdELDRCQUFRLEdBQVIsVUFBUyxLQUFtQjtRQUMxQixJQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQzdCLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDVixFQUFFLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO2dCQUNiLE1BQU0sSUFBSSxLQUFLLEVBQUUsQ0FBQztZQUNwQixDQUFDO1lBQ0QsSUFBSSxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUM7WUFDcEIsSUFBSSxDQUFDLFdBQVcsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUMxQixDQUFDO1FBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUM7WUFDcEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUM7WUFDbkIsSUFBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUN6QixDQUFDO0lBQ0gsQ0FBQztJQUVTLCtCQUFXLEdBQXJCLFVBQXNCLEtBQW1CO0lBRXpDLENBQUM7SUFFRCx1Q0FBbUIsR0FBbkIsVUFBb0IsVUFBaUI7SUFFckMsQ0FBQztJQUVELHVDQUFtQixHQUFuQixVQUFvQixVQUFpQjtJQUVyQyxDQUFDO0lBRUQsK0JBQVcsR0FBWDtJQUVBLENBQUM7SUFFRCw4QkFBVSxHQUFWO0lBRUEsQ0FBQztJQUVELCtCQUFXLEdBQVgsVUFBWSxLQUFhLEVBQUUsS0FBZ0I7SUFFM0MsQ0FBQztJQUVELDhCQUFVLEdBQVYsVUFBVyxLQUFhLEVBQUUsS0FBZ0I7SUFFMUMsQ0FBQztJQUVELDJCQUFPLEdBQVAsVUFBUSxJQUFZO0lBRXBCLENBQUM7SUFFRCw0QkFBUSxHQUFSLFVBQVMsS0FBYTtJQUV0QixDQUFDO0lBRUQseUJBQUssR0FBTDtRQUNFLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO1lBQ2hCLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssRUFBRSxDQUFDO1FBQzdCLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLE1BQU0sQ0FBQyxTQUFTLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUN6QyxDQUFDO0lBQ0gsQ0FBQztJQUVELCtCQUFXLEdBQVgsVUFBWSxLQUFnQjtJQUU1QixDQUFDO0lBQ0gsZ0JBQUM7QUFBRCxDQUFDLEFBMUVELElBMEVDIn0=